import { render, staticRenderFns } from "./DebtCollectorProjectAssignment.vue?vue&type=template&id=488e8a70&"
import script from "./DebtCollectorProjectAssignment.vue?vue&type=script&lang=js&"
export * from "./DebtCollectorProjectAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports